import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2988f77d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = { class: "bg_list" }
const _hoisted_3 = { class: "bg_list_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "投料明细")
  ])
], -1))
const _hoisted_5 = { class: "bg_list_item_num" }
const _hoisted_6 = { class: "bg_list_item_num_item" }
const _hoisted_7 = { class: "bg_list_item_num_item_wl" }
const _hoisted_8 = { class: "bg_list_item_num_item_wl_lx" }
const _hoisted_9 = {
  key: 0,
  class: "green"
}
const _hoisted_10 = {
  key: 1,
  class: "yellow"
}
const _hoisted_11 = {
  key: 2,
  class: "red"
}
const _hoisted_12 = { class: "bg_list_item_num_item_sr" }
const _hoisted_13 = {
  key: 1,
  class: "kong"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "bg_list_item" }
const _hoisted_17 = { class: "bg_list_item_top" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "产出明细")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看检验记录", -1))
const _hoisted_20 = { class: "bg_list_item_num" }
const _hoisted_21 = { class: "bg_list_item_num_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "良品数", -1))
const _hoisted_23 = { class: "bg_list_item_num_item_sr" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "bg_list_item_num" }
const _hoisted_26 = { class: "bg_list_item_num_item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良数", -1))
const _hoisted_28 = { class: "bg_list_item_num_item_sr" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "details_dj" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_dj_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "details_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "生产点检")
], -1))
const _hoisted_32 = { class: "details_dj_list" }

import {ref, onMounted, getCurrentInstance, reactive} from 'vue'
    import { useRouter, useRoute } from "vue-router"
    import {deleteCT, getOrocessRecord, listGroupByAppliance, pageDJ, queryById, allForStandard, getWorkorderRecordListStandard} from '@/apis/WorkOrderAPI'
    import { Dialog } from 'vant'
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { proxy }: any = getCurrentInstance()
    const router = useRouter()

    const route = useRoute()

    const loading = ref(false);
    const finished = ref(false);

    // 点检数据
    let djData: any = ref([])

    // 投料
    let feedingData: any = ref([])

    // 产出
    let produceData: any = ref([])

    // 不良
    let undesirable: any = ref([])

    // 报废
    let scrap: any = ref([])

    let info: any = ref({})

    // 产出合格/不良
    let produceFrom = reactive({
        qualifiedId: '',
        qualified: '',  // 合格
        undesirableId: '',
        undesirable: '' // 不良
    })

    // 分页查询数据
    let page = reactive({
        capacity: 10,
        page: 0
    })

    // 点检数据
    const pageDJs = () => {
        if (!finished.value) {
            page.page = page.page + 1
            loading.value = true
            pageDJ({
                capacity: page.capacity,
                page: page.page,
                model: {
                    workorderId: route.query.id
                }
            }).then(res => {
                if (res.code === 200 && res.data && res.data.records.length !== 0) {
                    djData.value.push(...res.data.records)
                } else {
                    finished.value = true
                }
                loading.value = false
            }).catch(err => {
                loading.value = false
                finished.value = true
            })
        }
    }

    // 报废统计
    const bfTotal = (): string => {
        if (scrap.value.length > 0) {
            let total: number = 0
            scrap.value.forEach((element: any) => {
                total = total + element.num
            })
            return `${total}${scrap.value[0].dw}`
        }
        return ''
    }

    // 不良统计
    const blTotal = (): string => {
        if (undesirable.value.length > 0) {
            let total: number = 0
            undesirable.value.forEach((element: any) => {
                total = total + element.num
            })
            return `${total}${undesirable.value[0].dw}`
        }
        return ''
    }

    // 产出统计
    const ccTotal = (): string => {
        if (produceData.value.length > 0) {
            let total: number = 0
            produceData.value.forEach((element: any) => {
                total = total + element.num
            })
            return `${total}${produceData.value[0].dw}`
        }
        return ''
    }

    // 投料统计
    const tlTotal = (): string => {
        if (feedingData.value.length > 0) {
            let total: number = 0
            feedingData.value.forEach((element: any) => {
                total = total + element.num
            })
            return `${total}${feedingData.value[0].dw}`
        }
        return ''
    }

    // 跳转完工入库
    const jumpRK = () => {
        router.push({ name: 'wipCompletion' })
    }

    // 删除产出/投料
    const deleItem = (id: any, type: string) => {
        Dialog.confirm({
            title: '提示',
            message: '确定删除此条记录吗？',
        })
            .then(() => {
                deleteCT(id)
                    .then(res => {
                        if (res.code === 200 && type === 'C') {
                            getOrocessRecordCC()
                        } else if (res.code === 200 && type === 'T') {
                            getOrocessRecords()
                        }
                    })
            })
            .catch(() => {

            })
    }

    // 查询工单生产记录---投料
    const getOrocessRecords = () => {
        feedingData.value = []
        allForStandard({
            workorderId: route.query.id,
            type: 0
        }).then(res => {
            if (res.code === 200) {
                feedingData.value = res.data
                // res.data.forEach((item: any) => {
                //     feedingData.value.push({ id: item.id, dw: item.umodel.name, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num })
                // })
            }
        })
    }

    // 查询工单生产记录---产出(合格)
    const getOrocessRecordCC = () => {
        produceData.value = []
        getWorkorderRecordListStandard({
            workorderId: route.query.id
        }).then(res => {
            if (res.code === 200) {
                if (res.data.length > 0) {
                    produceFrom.qualified = res.data[0].qualifiedNum
                    produceFrom.undesirable = res.data[0].unqualifiedNum
                    // res.data.forEach((item: any) => {
                    //     if (item.doneType === 1) {
                    //         produceFrom.undesirable = item.num
                    //         produceFrom.undesirableId = item.id
                    //     } else {
                    //         produceFrom.qualified = item.num
                    //         produceFrom.qualifiedId = item.id
                    //     }
                    // })
                }
                // res.data.forEach((item: any) => {
                //     if (item.doneType === 0) { // 合格
                //         produceData.value.push({ id: item.id, dw: item.umodel.name, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num })
                //     } else if (item.doneType === 1) { // 不良
                //         undesirable.value.push({ id: item.id, dw: item.umodel.name, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num })
                //     } else if (item.doneType === 2) { // 报废
                //         scrap.value.push({ id: item.id, dw: item.umodel.name, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num })
                //     }
                // })
            }
        })
    }

    // 查询工单生产记录---产出(不良)
    const getOrocessRecordBL = () => {
        undesirable.value = []
        getOrocessRecord({
            workorderId: route.query.id,
            type: 1,
            done_type: 1
        }).then(res => {
            if (res.code === 200) {
                res.data.forEach((item: any) => {
                    undesirable.value.push({ id: item.id, dw: item.umodel.name, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num })
                })
                console.log(undesirable.value)
            }
        })
    }

    // 查询工单生产记录---产出(报废)
    const getOrocessRecordBF = () => {
        scrap.value = []
        getOrocessRecord({
            workorderId: route.query.id,
            type: 1,
            done_type: 2
        }).then(res => {
            if (res.code === 200) {
                res.data.forEach((item: any) => {
                    scrap.value.push({ id: item.id, dw: item.umodel.name, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num })
                })
            }
        })
    }

    // 查询不良产出明细
    const listGroupByAppliances = () => {
        listGroupByAppliance({
            workorderId: route.query.id
        }).then(res => {
            if (res.code === 200 && res.data && res.data.length !== 0) {
                undesirable.value = res.data
            }
        })
    }

    const jump = () => {
        router.push({ name: 'manualFeeding' })
    }

    const jumpTest = (code: string) => {
        // console.log(info.value)
        router.push({ name: 'exWarehouse', query: { id: code } })
    }

    // 获取详情数据
    const queryByIds = () => {
        queryById(route.query.id).then(res => {
            if (res.code === 200) {
                info.value = res.data
            }
        })
    }

    onMounted(() => {
        queryByIds()
        getOrocessRecords()
        getOrocessRecordCC()
        // listGroupByAppliances()
        // getOrocessRecordBL()
        // getOrocessRecordBF()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VWorkOrderInfo, { info: _unref(info) }, null, 8, ["info"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_unref(feedingData) && _unref(feedingData).length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(feedingData), (item, index) => {
              return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", null, _toDisplayString(item.materialName) + _toDisplayString(item.procedureName ? ` | ${item.procedureName}` : ''), 1),
                        _createElementVNode("div", _hoisted_8, [
                          (item.qualityType == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "合格 / "))
                            : _createCommentVNode("", true),
                          (item.qualityType == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "不良 / "))
                            : _createCommentVNode("", true),
                          (item.qualityType == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "报废 / "))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(item.locationName), 1),
                          _createElementVNode("span", null, _toDisplayString(item.batch ? ` / ${item.batch}` : ''), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", null, _toDisplayString(item.num) + " " + _toDisplayString(item.unitName), 1)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", {
            class: "bg_list_item_top_right",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (jumpTest(_unref(info).id)))
          }, [
            _hoisted_19,
            _createVNode(_component_van_icon, {
              name: "arrow",
              color: "#4275FC"
            })
          ])
        ]),
        _createVNode(_component_van_swipe_cell, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  (_unref(info).umodel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(produceFrom).qualified) + " " + _toDisplayString(_unref(info).umodel.name), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_swipe_cell, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  (_unref(info).umodel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(produceFrom).undesirable) + " " + _toDisplayString(_unref(info).umodel.name), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
            finished: finished.value,
            "finished-text": "没有更多了~",
            onLoad: pageDJs
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(djData), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "details_dj_list_item",
                  key: index
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.attrName) + "：" + _toDisplayString(item.val), 1),
                  _createElementVNode("span", null, _toDisplayString(item.userName) + " " + _toDisplayString(item.createTime), 1)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished"])
        ])
      ])
    ])
  ]))
}
}

})